var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-text-centered"},[_c('a',{staticClass:"m-t-xl m-b-xl is-block has-text-weight-bold",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go back")]),_c('a',{staticClass:"m-t-xl m-b-xl is-block",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("Go to Hangfire")])])
}
var staticRenderFns = []

export { render, staticRenderFns }